import axios, { getData } from "lib/axios";
import { useQuery, useMutation, useQueryClient } from "react-query";

export const useGetWorkday = () =>
  useQuery(["workday"], async () => {
    const res = await axios.get(`/admin/workday`).then(getData);
    return res.data;
  });

export const usePostWorkday = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (postData) => {
      const res = await axios.post(`/admin/workday`, postData);
      return res;
    },
    {
      onSuccess: () => {
        // invalidate current workdays and refetch
        queryClient.invalidateQueries("workday");
        queryClient.invalidateQueries("disabled-date");
      },
    }
  );
};
